import dayjs from 'dayjs';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logo from '../images/logo.png';
import { ComplaintDTO } from '../types/ComplaintDTO';

export class PdfService {
	public exportComplaintsToPdf(complaints: ComplaintDTO[], fileName?: string): void {
		const doc = new jsPDF();

		const formatDate = (v: number | string |null | undefined) => {
			if (!v) return "-";
			return dayjs(v).format("DD/MM/YYYY HH:mm");
		}

		const addHeader = () => {
			doc.addImage(logo, 'PNG', 15, 10, 40, 20);
			doc.setFontSize(18);
			doc.text('Relatório de Denúncias', doc.internal.pageSize.getWidth() / 2, 20, { align: 'center' });
		};

		addHeader();
		doc.setFontSize(10);
		doc.text(`Data de Emissão: ${new Date().toLocaleDateString('pt-BR')}`, 15, 35);

		let yPosition = 45;

		const checkPageBreak = (neededHeight: number) => {
			if (yPosition + neededHeight > doc.internal.pageSize.getHeight() - 15) {
				doc.addPage();
				addHeader();
				yPosition = 40;
			}
		};

		complaints.forEach((complaint, index) => {
			if (index > 0) {
				doc.addPage();
				addHeader();
				yPosition = 40;
			}
			doc.setFontSize(14);
			doc.setFont('helvetica', 'bold');
			doc.text(`Denúncia - Protocolo: ${complaint.id}`, 15, yPosition);
			yPosition += 8;
			doc.setFontSize(10);
			doc.setFont('helvetica', 'normal');
			const addField = (label: string, value: string | null | undefined) => {
				const text = value || 'Não informado';
				const splitText = doc.splitTextToSize(text, 100);
				checkPageBreak(splitText.length * 5 + 2);
				doc.setFont('helvetica', 'bold');
				doc.text(`${label}:`, 15, yPosition);
				doc.setFont('helvetica', 'normal');
				doc.text(splitText, 100, yPosition);
				yPosition += splitText.length * 4 + 4;
			};
			addField('Status', complaint.status);
			addField('Prioridade', complaint.priority);
			addField('Data de Registro', formatDate(complaint.createdAt));
			addField('Empresa', complaint.companyName);
			addField('Setor', complaint.sector);
			addField('Cargo', complaint.position);
			addField('Tipo (Denunciante)', complaint.complaintType);
			addField('Descrição', complaint.description);
			addField('Anexos', complaint.files?.split(',').join(', '));
			yPosition += 3;
			checkPageBreak(20);
			doc.setFont('helvetica', 'bold');
			doc.text('Classificação Final:', 15, yPosition);
			yPosition += 5;
			doc.setFont('helvetica', 'normal');
			addField('  - Tipo (Gestor)', complaint.finalType);
			addField('  - Critérios', complaint.criteria?.split(',').join(', '));
			yPosition += 3;
			checkPageBreak(25);
			doc.setFont('helvetica', 'bold');
			doc.text('Histórico:', 15, yPosition);
			yPosition += 5;
			doc.setFont('helvetica', 'normal');
			if (!!complaint.history?.length) {
				complaint.history.forEach(history => {
					addField(`  ${history.description}`, formatDate(history.createdAt));
				})
			}
			if (complaint.actions && complaint.actions.length > 0) {
				checkPageBreak(20);
				autoTable(doc, {
					head: [['Descrição', 'Responsável', 'Prazo', 'Conclusão']],
					body: complaint.actions.map(action => [ action.description || '', action.username || 'N/A', action.deadline || '', action.conclusion || '' ]),
					startY: yPosition,
					theme: 'grid',
					headStyles: { fillColor: [33, 150, 243] },
					didDrawPage: (data: any) => { addHeader(); yPosition = data.cursor?.y ?? 40; }
				});
				yPosition = (doc as any).lastAutoTable.finalY + 10;
			}
		});
		doc.save(fileName || 'denuncias_filtradas.pdf');
	}
}